import { Table, Column, Cell, ColumnHeaderCell } from 'callahan-react'
import React from 'react'

import './manifest-info.css'
import { formatDate, daysAgoForDate, daysAgoAsInt } from '../../utils/date-utils.js'

class ManifestTable extends React.Component {
  renderCell = (index, prop, modifier) => {
    const { displayData } = this.props
    const data = displayData[index]
    return (
      <Cell
        key={data.name}
        className={`manifest-cell ${daysAgoAsInt(data.end_date) >= 10 ? 'manifest-highlight' : ''}`}
      >
        <h5 className="cell-header">
          {typeof modifier !== 'undefined' ? modifier(data[prop]) : data[prop]}
        </h5>
      </Cell>
    )
  }

  renderNameCell = rowIndex => this.renderCell(rowIndex, 'name')

  renderPathCell = rowIndex => this.renderCell(rowIndex, 'path')

  renderStartDateCell = rowIndex => this.renderCell(rowIndex, 'start_date', formatDate)

  renderEndDateCell = rowIndex => this.renderCell(rowIndex, 'end_date', formatDate)

  renderUpdatedCell = rowIndex => this.renderCell(rowIndex, 'end_date', daysAgoForDate)

  render() {
    const { displayData } = this.props
    const cols = [
      {
        title: 'File Name',
        key: 'name',
        render: this.renderNameCell
      },
      {
        title: 'Path',
        key: 'path',
        render: this.renderPathCell
      },
      {
        title: 'Start Date',
        key: 'start',
        render: this.renderStartDateCell
      },
      {
        title: 'End Date',
        key: 'end',
        render: this.renderEndDateCell
      },
      {
        title: 'Last Updated',
        key: 'updated',
        render: this.renderUpdatedCell
      }
    ].map(col => {
      return (
        <Column
          key={col.key}
          header={
            <ColumnHeaderCell key={col.key + '-header'}>
              <h4>{col.title}</h4>
            </ColumnHeaderCell>
          }
          renderCell={col.render}
          grow={true}
        />
      )
    })

    return (
      <div>
        <div className="manifest-info-table-holder">
          <Table displayData={displayData} grow={true}>
            {cols}
          </Table>
        </div>
      </div>
    )
  }
}
export default ManifestTable



// WEBPACK FOOTER //
// ./src/pages/ManifestInfo/ManifestTable.js